(function () {
    'use strict';

    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAvailabilityFilters);
    } else {
        initAvailabilityFilters();
    }

    function initAvailabilityFilters() {
        var wrappers = document.querySelectorAll('.custom-variant-picker-wrapper');

        wrappers.forEach(function (wrapper) {
            var variantPicker = wrapper.querySelector('variant-picker');
            var buttons = wrapper.querySelectorAll('[data-availability-btn]');

            if (!variantPicker || buttons.length === 0) return;

            // Wait for variant picker to load product data
            var checkProductLoaded = setInterval(function () {
                if (variantPicker.product && variantPicker.product.variants) {
                    clearInterval(checkProductLoaded);
                    setupFilters();
                }
            }, 100);

            // Timeout after 5 seconds
            setTimeout(function () {
                clearInterval(checkProductLoaded);
                if (variantPicker.product && variantPicker.product.variants) {
                    setupFilters();
                }
            }, 5000);

            function setupFilters() {
                // Get gender filter elements
                var genderSelect = wrapper.querySelector('[data-gender-filter-select]');
                var genderHiddenInput = wrapper.querySelector('[data-gender-filter]');

                // Handle gender filter change
                if (genderSelect) {
                    genderSelect.addEventListener('change', function () {
                        var selectedGender = this.value;
                        if (genderHiddenInput) {
                            genderHiddenInput.value = selectedGender;
                        }
                        applyGenderFilter(selectedGender);

                        // Re-apply availability filter after gender change
                        var currentMode = variantPicker.getAttribute('data-availability-mode');
                        if (currentMode === 'in_stock') {
                            setTimeout(function () {
                                updateVariantStates(true);
                            }, 50);
                        }
                    });

                    // Initial gender filter
                    var initialGender = genderSelect.value || (genderHiddenInput ? genderHiddenInput.value : 'men');
                    applyGenderFilter(initialGender);
                }

                // Handle button clicks
                buttons.forEach(function (btn) {
                    btn.addEventListener('click', function () {
                        var mode = this.dataset.mode;

                        // Update button states
                        buttons.forEach(function (b) {
                            if (b === btn) {
                                b.classList.remove('button--outline');
                            } else {
                                b.classList.add('button--outline');
                            }
                        });

                        // Update variant picker attribute
                        if (mode === 'in_stock') {
                            variantPicker.setAttribute('hide-sold-out-variants', '');
                            variantPicker.setAttribute('data-availability-mode', 'in_stock');
                            // Small delay to ensure DOM is ready
                            setTimeout(function () {
                                updateVariantStates(true);
                            }, 50);
                        } else {
                            variantPicker.removeAttribute('hide-sold-out-variants');
                            variantPicker.setAttribute('data-availability-mode', 'mto');
                            setTimeout(function () {
                                updateVariantStates(false);
                            }, 50);
                        }

                        // Trigger variant picker update
                        if (typeof variantPicker._updateDisableSelectors === 'function') {
                            variantPicker._updateDisableSelectors();
                        }
                    });
                });

                // Initial state update - check if in_stock mode is set
                var currentMode = variantPicker.getAttribute('data-availability-mode');
                if (currentMode === 'in_stock') {
                    // Small delay to ensure DOM is fully ready
                    setTimeout(function () {
                        updateVariantStates(true);
                    }, 100);
                } else {
                    updateVariantStates(false);
                }

                // Also listen for variant picker updates to re-check availability
                variantPicker.addEventListener('variant:change', function () {
                    var mode = variantPicker.getAttribute('data-availability-mode');
                    if (mode === 'in_stock') {
                        setTimeout(function () {
                            updateVariantStates(true);
                        }, 50);
                    }
                });

                // Watch for attribute changes on variant-picker
                var observer = new MutationObserver(function (mutations) {
                    mutations.forEach(function (mutation) {
                        if (mutation.type === 'attributes' && mutation.attributeName === 'data-availability-mode') {
                            var mode = variantPicker.getAttribute('data-availability-mode');
                            setTimeout(function () {
                                updateVariantStates(mode === 'in_stock');
                            }, 50);
                        }
                    });
                });
                observer.observe(variantPicker, { attributes: true, attributeFilter: ['data-availability-mode'] });
            }

            // Helper function to add stock status indicator
            function addStockIndicator(element, inStock) {
                // Remove existing indicator
                removeStockIndicator(element);

                // Create indicator element
                var indicator = document.createElement('span');
                indicator.className = 'variant-stock-indicator';
                indicator.setAttribute('data-stock-status', inStock ? 'in-stock' : 'out-of-stock');
                indicator.textContent = inStock ? 'In Stock' : 'Out of Stock';
                indicator.style.cssText = 'position: absolute; top: 2px; right: 2px; font-size: 10px; padding: 2px 4px; border-radius: 2px; font-weight: bold; z-index: 10; pointer-events: none;';

                if (inStock) {
                    indicator.style.background = '#10b981';
                    indicator.style.color = '#fff';
                } else {
                    indicator.style.background = '#ef4444';
                    indicator.style.color = '#fff';
                }

                // Ensure parent has position relative
                if (getComputedStyle(element).position === 'static') {
                    element.style.position = 'relative';
                }

                element.appendChild(indicator);
            }

            // Helper function to remove stock indicator
            function removeStockIndicator(element) {
                var existing = element.querySelector('.variant-stock-indicator');
                if (existing) {
                    existing.remove();
                }
            }

            // Function to apply gender filter
            function applyGenderFilter(selectedGender) {
                if (!selectedGender) return;

                // console.log('Applying gender filter:', selectedGender);

                // Normalize gender value - check women first because "women" contains "men"
                var normalizedGender = selectedGender.toLowerCase().trim();
                if (normalizedGender.includes('women') || normalizedGender === 'female') {
                    normalizedGender = 'women';
                } else if (normalizedGender.includes('men') || normalizedGender === 'male') {
                    normalizedGender = 'men';
                } else if (normalizedGender.includes('children') || normalizedGender === 'child' || normalizedGender === 'kids') {
                    normalizedGender = 'children';
                }

                // Get all variant options with gender filter check
                var variantOptions = variantPicker.querySelectorAll('[data-gender-filter-check]');
                var visibleCount = 0;
                var hiddenCount = 0;

                variantOptions.forEach(function (optionElement) {
                    var variantGender = optionElement.getAttribute('data-variant-gender');

                    if (variantGender) {
                        var normalizedVariantGender = variantGender.toLowerCase().trim();
                        // Normalize variant gender - check women first because "women" contains "men"
                        if (normalizedVariantGender.includes('women') || normalizedVariantGender === 'female') {
                            normalizedVariantGender = 'women';
                        } else if (normalizedVariantGender.includes('men') || normalizedVariantGender === 'male') {
                            normalizedVariantGender = 'men';
                        } else if (normalizedVariantGender.includes('children') || normalizedVariantGender === 'child' || normalizedVariantGender === 'kids') {
                            normalizedVariantGender = 'children';
                        }

                        // Show/hide based on gender match
                        if (normalizedVariantGender === normalizedGender) {
                            optionElement.removeAttribute('hidden');
                            optionElement.style.display = '';
                            visibleCount++;
                        } else {
                            optionElement.setAttribute('hidden', 'true');
                            optionElement.style.display = 'none';
                            hiddenCount++;
                        }
                    } else {
                        // If no gender data, show it (for backwards compatibility)
                        optionElement.removeAttribute('hidden');
                        optionElement.style.display = '';
                        visibleCount++;
                    }
                });

                // console.log('Gender filter applied - Visible:', visibleCount, 'Hidden:', hiddenCount);
            }

            function updateVariantStates(inStockMode) {
                if (!variantPicker.product || !variantPicker.product.variants) {
                    console.warn('Variant picker product data not loaded yet');
                    return;
                }

                var variants = variantPicker.product.variants;
                var optionSelectors = variantPicker.querySelectorAll('[data-option-selector]');

                // console.log('=== Updating variant states ===');
                // console.log('Mode:', inStockMode ? 'In Stock' : 'Made to Order');
                // console.log('Total variants:', variants.length);
                // console.log('Option selectors found:', optionSelectors.length);

                // // Log variant availability for debugging
                // if (variants.length > 0) {
                //     console.log('Sample variant:', variants[0]);
                //     console.log('Available variants:', variants.filter(function (v) { return v.available; }).length);
                // }

                // If in_stock mode, check all variants for availability
                if (inStockMode) {
                    // First, get all currently selected option values
                    var selectedOptions = {};
                    optionSelectors.forEach(function (selector, index) {
                        var optionName = 'option' + (index + 1);
                        var selectedInput = selector.querySelector('input[type="radio"]:checked, input[type="hidden"][name="' + optionName + '"]');
                        if (selectedInput) {
                            selectedOptions[optionName] = selectedInput.value;
                        }
                    });
                }

                optionSelectors.forEach(function (selector, selectorIndex) {
                    var optionPosition = selectorIndex + 1;
                    var optionName = 'option' + optionPosition;

                    // console.log('Processing option selector', optionPosition, 'Option name:', optionName);

                    // Get all wrapper divs with variant-option class (these are the main containers)
                    var variantOptionWrappers = selector.querySelectorAll('.variant-option');

                    // console.log('Found variant option wrappers:', variantOptionWrappers.length);

                    // Also try to find by data-option-value if no .variant-option found
                    if (variantOptionWrappers.length === 0) {
                        variantOptionWrappers = selector.querySelectorAll('[data-option-value]');
                        // console.log('Found elements with data-option-value:', variantOptionWrappers.length);
                    }

                    // Also get swatch elements as fallback
                    var optionValueElements = selector.querySelectorAll('label[for^="swatch"], .swatch, .block-swatch, .media-swatch, button[data-option-value]');

                    // Process wrapper divs first (these are the main containers shown in screenshot)
                    variantOptionWrappers.forEach(function (wrapperElement) {
                        // Get the value from data-option-value attribute
                        var value = wrapperElement.getAttribute('data-option-value');

                        // Skip if no value found
                        if (!value || value === '') {
                            console.warn('Wrapper element found but no data-option-value:', wrapperElement);
                            return;
                        }

                        // console.log('Processing variant option:', value);

                        // Get variant ID if available
                        var variantId = wrapperElement.getAttribute('data-variant-id');
                        var optionType = wrapperElement.getAttribute('data-option-type') || '';

                        // Find all variants with this option value at this position
                        var variantsWithValue = variants.filter(function (variant) {
                            var variantOptionValue = variant[optionName];
                            return variantOptionValue === value || String(variantOptionValue) === String(value);
                        });

                        // console.log('Variants with value "' + value + '":', variantsWithValue.length);
                        if (variantsWithValue.length > 0) {
                            // console.log('Sample variant:', variantsWithValue[0]);
                            // console.log('Available count:', variantsWithValue.filter(function (v) { return v.available; }).length);
                        }

                        // Check if any variant with this value is available
                        // For in_stock mode, we need to check if there's at least one available variant
                        var hasAvailableVariant = false;
                        if (inStockMode) {
                            // In Stock mode: check if any variant with this option value has stock
                            if (variantsWithValue.length > 0) {
                                // Check if any variant with this option value is available
                                hasAvailableVariant = variantsWithValue.some(function (variant) {
                                    // Check if variant is available (has stock)
                                    // Try multiple ways to check availability
                                    return variant.available === true ||
                                        variant.available === 'true' ||
                                        variant.available === 1 ||
                                        (variant.inventory_quantity !== undefined && variant.inventory_quantity > 0);
                                });
                            } else {
                                // No variants found with this value - disable it
                                hasAvailableVariant = false;
                            }
                        } else {
                            // Made to Order mode - all variants are available
                            hasAvailableVariant = true;
                        }

                        // console.log('Has available variant:', hasAvailableVariant);

                        // Find related elements within the wrapper
                        var inputElement = wrapperElement.querySelector('input[type="radio"]');
                        var labelElement = wrapperElement.querySelector('label');
                        var swatchElement = wrapperElement.querySelector('.swatch, .block-swatch, .media-swatch, .color-swatch');

                        if (inStockMode) {
                            // In Stock mode: disable unavailable variants
                            if (!hasAvailableVariant) {
                                // Apply disabled state to wrapper div (main container)
                                wrapperElement.setAttribute('data-disabled', 'true');
                                wrapperElement.style.opacity = '0.5';
                                wrapperElement.style.pointerEvents = 'none';
                                wrapperElement.style.cursor = 'not-allowed';
                                wrapperElement.style.position = 'relative'; // For ::after pseudo-element

                                // Add stock status indicator
                                addStockIndicator(wrapperElement, false);

                                // console.log('✓ Disabled variant option:', value, 'Variant ID:', variantId, 'Type:', optionType);
                                // console.log('  Element:', wrapperElement);
                                // console.log('  Has data-disabled:', wrapperElement.hasAttribute('data-disabled'));
                            } else {
                                // Enable available variants - remove all disabled states
                                wrapperElement.removeAttribute('data-disabled');
                                wrapperElement.style.opacity = '';
                                wrapperElement.style.pointerEvents = '';
                                wrapperElement.style.cursor = '';

                                // Add stock status indicator for available variants
                                addStockIndicator(wrapperElement, true);
                                // console.log('✓ Enabled variant option:', value);

                                if (inputElement) {
                                    inputElement.disabled = false;
                                    inputElement.removeAttribute('data-disabled');
                                }

                                if (labelElement) {
                                    labelElement.removeAttribute('data-disabled');
                                    labelElement.style.pointerEvents = '';
                                }
                                if (swatchElement) {
                                    swatchElement.removeAttribute('data-disabled');
                                    swatchElement.style.pointerEvents = '';
                                }
                            }
                        } else {
                            // Made to Order mode: enable all variants
                            wrapperElement.removeAttribute('data-disabled');
                            wrapperElement.style.opacity = '';
                            wrapperElement.style.pointerEvents = '';
                            wrapperElement.style.cursor = '';

                            // Remove stock indicator
                            removeStockIndicator(wrapperElement);

                            if (inputElement) {
                                inputElement.disabled = false;
                                inputElement.removeAttribute('data-disabled');
                            }

                            if (labelElement) {
                                labelElement.removeAttribute('data-disabled');
                                labelElement.style.pointerEvents = '';
                            }
                            if (swatchElement) {
                                swatchElement.removeAttribute('data-disabled');
                                swatchElement.style.pointerEvents = '';
                            }
                        }
                    });

                    // Also process individual swatch elements as fallback (for backwards compatibility)
                    optionValueElements.forEach(function (optionElement) {
                        // Skip if already processed as part of a wrapper
                        if (optionElement.closest('.variant-option')) return;

                        // Get the value from various possible sources
                        var value = optionElement.getAttribute('data-option-value') ||
                            optionElement.getAttribute('value') ||
                            optionElement.textContent.trim();

                        // Skip if no value found
                        if (!value || value === '') return;

                        // Find all variants with this option value at this position
                        var variantsWithValue = variants.filter(function (variant) {
                            return variant[optionName] === value;
                        });

                        // Check availability
                        var hasAvailableVariant = false;
                        if (inStockMode) {
                            if (variantsWithValue.length > 0) {
                                hasAvailableVariant = variantsWithValue.some(function (variant) {
                                    return variant.available === true || variant.available === 'true';
                                });
                            }
                        } else {
                            hasAvailableVariant = true;
                        }

                        // Find wrapper
                        var wrapperElement = optionElement.closest('[data-option-value-wrapper]') || optionElement.parentElement;
                        var inputElement = wrapperElement.querySelector('input[type="radio"]') || selector.querySelector('input[type="radio"][name="' + optionName + '"][value="' + CSS.escape(value) + '"]');

                        if (inStockMode && !hasAvailableVariant) {
                            if (optionElement.tagName === 'LABEL' || optionElement.classList.contains('swatch')) {
                                optionElement.setAttribute('data-disabled', 'true');
                                optionElement.style.opacity = '0.5';
                                optionElement.style.pointerEvents = 'none';
                                optionElement.style.cursor = 'not-allowed';
                            }
                            if (inputElement) {
                                inputElement.disabled = true;
                                inputElement.setAttribute('data-disabled', 'true');
                            }
                            if (wrapperElement && !wrapperElement.classList.contains('variant-option')) {
                                wrapperElement.setAttribute('data-disabled', 'true');
                                wrapperElement.style.opacity = '0.5';
                                wrapperElement.style.pointerEvents = 'none';
                            }
                        } else {
                            if (optionElement.tagName === 'LABEL' || optionElement.classList.contains('swatch')) {
                                optionElement.removeAttribute('data-disabled');
                                optionElement.style.opacity = '';
                                optionElement.style.pointerEvents = '';
                                optionElement.style.cursor = '';
                            }
                            if (inputElement) {
                                inputElement.disabled = false;
                                inputElement.removeAttribute('data-disabled');
                            }
                            if (wrapperElement && !wrapperElement.classList.contains('variant-option')) {
                                wrapperElement.removeAttribute('data-disabled');
                                wrapperElement.style.opacity = '';
                                wrapperElement.style.pointerEvents = '';
                            }
                        }
                    });
                });
            }
        });
    }
})();
